<template>
  <v-clappr :el="htmlId" :source="source" :options="options" @init="oninit" @error="onerror" />
</template>

<script>
  import VClappr from 'v-clappr'
  import { Browser } from 'clappr'
  import { apiQuery } from "../api"


  export default {
    name: "Archive",
    components: { VClappr },
    props: {
      htmlId: String,
      id: String,
      from: String,
      to: String,
      height: {
        type: String,
        default: '38vh'
      }
    },
    data() {
      return {
        source: "",
        player: null,
        loading: false,
        options: {
          width: 'auto',
          height: this.height,
          poster: '',
          mute: true,
          autoplay: true,
          loop: false,
          disable_context_menu: false,
          disable_keyboard_shortcuts: false,
          mediacontrol: {},
          ga: {
            account: '',
            tracker_name: '',
          },
          watermark: {
            image: '',
            url: '',
            position: 'top-right',
          },
          plugins: [],
          chromeless: false,
          allow_user_interaction: false,
          i18n: {
            en: {
              live: 'прямая трансляция',
              back_to_live: 'вернуться к трансляции',
              disabled: 'выключено',
              playback_not_supported: 'Похоже, ваш браузер не поддерживает трансляцию',
              default_error_title: 'Не удалось воспроизвести видео',
              default_error_message: 'Проблема при загрузке видео. Повтор....',
            },
          },
          mime_type: '',
          actual_live_time: '',
          preload: '',
          playback: {
            preload: 'metadata',
            controls: false,
            playInline: true, // allows inline playback when running on iOS UIWebview
            crossOrigin: '',
            recycleVideo: Browser.isMobile, // Recycle <video> element only for mobile. (default is true)
            triggerFatalErrorOnResourceDenied: true, // Triggers playback fatal error if resource is denied. (default is false)
            externalTracks: [],
            hlsUseNextLevel: false,
            hlsjsConfig: {},
          },
          cc: {
            title: '',
            ariaLabel: '',
            labelCallback: () => {},
          },
        },
      }
    },
    watch: {
      id: {
        handler () {
          if (!this.loading)
            this.loadStream()
        },
        immediate: true
      },
      from: {
        handler () {
          if (!this.loading)
            this.loadStream()
        },
        immediate: true
      },
      to: {
        handler () {
          if (!this.loading)
            this.loadStream()
        },
        immediate: true
      }
    },
    mounted() {

    },
    methods: {
      oninit(clappr) {
        this.player = clappr;
      },

      onerror(error) {
        if (error.raw.response.code === 404) {
          setTimeout(() => {
            this.updateSource()
          }, 1000)
        }
      },

      updateSource() {

       // const s = this.player.options.source;
        const o = this.player.options;
        o.source = this.source;
        this.player.configure(o);
      },

      loadStream() {
        this.loading = true
        return apiQuery('private', 'action-execute', {
          action: 'C0718BFC55FB41C0BEF310C51E76C51B',
          recordIds: [this.id],
          parameters: [
            {
              table: '5CEAC7661C0541DEA02DC6A34BDD73AD',
              data: {
                SINCE_DATE: this.from,
                UNTIL_DATE: this.to
              }
            }
          ]
        }, false).then(res => {
          this.source = res.message
          if ( process.env.NODE_ENV === 'development')
            this.source = this.source.replace('https://smotrigia.pskovedu.ru', '')
          this.source = window.location.origin + (this.source.startsWith('/') ? '' : '/') + this.source
          this.$emit('loaded', res.message)
          this.updateSource()
          this.loading = false
        }).catch(() => {
          this.source = 'unknown'
          setTimeout(() => {
            this.updateSource()
          }, 1000)
          this.loading = false
        })
      }
    }
  }
</script>

